import { Mutation, OfferUpdateInput } from '@occc/graphql';
import { ScheduleFormValues } from './types';
import { Operation } from '../types';
import { mergeDateAndTime } from '../../lib/date';

type MakeOperation = (
  offerId: string,
  values: ScheduleFormValues,
) => Operation<'offerUpdate', { input: OfferUpdateInput }>;

export const makeOfferUpdateOperation: MakeOperation = (offerId, values) => {
  const publishAt = mergeDateAndTime(values.publishAtDate, values.publishAtTime);
  const expireAt = mergeDateAndTime(values.expireAtDate, values.expireAtTime);

  const input: OfferUpdateInput = {
    id: offerId,
    publishAt: publishAt?.toISOString() || null,
    expireAt: expireAt?.toISOString() || null,
    triggerPreferences: {
      ...values.triggerPreferences,
    },
  };

  return {
    name: 'offerUpdate' satisfies keyof Mutation,
    variables: {
      input,
    },
  };
};
